<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     参数显隐和排序
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-loading="loading" class="sen-rank">
    <div v-show="!selectedSens.length" class="row-display text-muted">
      <div class="index">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="all_checked"
          @change="allCheckChange"
        ></el-checkbox>
      </div>
      <div class="drag-button">排序</div>
      <div class="sen-name">参数名称</div>
      <div class="visiable-condition">显示条件</div>
      <div v-for="item in equipAuthArr" :key="item.value" class="role-user">{{ item.title }}</div>
    </div>
    <div v-show="selectedSens.length" class="row-display flex align-items-center">
      <div class="index">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="all_checked"
          @change="allCheckChange"
        ></el-checkbox>
      </div>
      <div class="sen-name flex align-items-center">
        <span class="mr">
          已选中
          <span :class="selectedSens.length ? 'text-success' : 'text-muted'">
            {{
            selectedSens.length
            }}
          </span>
          项
        </span>
        <el-button
          type="success"
          :disabled="!isIndeterminate || all_checked"
          size="mini"
          @click="moveTo"
        >排序</el-button>
        <el-button
          type="success"
          :disabled="!isIndeterminate && !all_checked"
          size="mini"
          @click="multiCreateCond(true)"
        >设置显示条件</el-button>
      </div>
    </div>

    <el-scrollbar class="row-wrapper v-only" :native="false">
      <draggable v-model="sens" class="row-inner" @update="dataChanged = true">
        <transition-group type="transition" :name="'flip-list'">
          <div v-for="(sen, index) in sens" :key="sen.senid" class="row-display">
            <div class="index">
              <div v-if="!sen.checked" class="index-number text-muted">{{ index + 1 }}</div>
              <el-checkbox
                :class="!sen.checked && 'index-checkbox'"
                v-model="sen.checked"
                @change="singleCheckChange($event, index)"
              ></el-checkbox>
            </div>
            <div class="drag-button">
              <span class="font-lg">
                <i class="iconfont icon-reorder text-muted"></i>
              </span>
            </div>
            <div class="sen-name">
              <span class="sen-name-text">{{ sen.sen_name }}</span>
            </div>
            <div class="visiable-condition">
              <div
                v-if="sen.cond_senid"
                class="cell-title"
                role="button"
                @click="singleCreateCond(sen)"
              >
                {{ sens_obj[sen.cond_senid].sen_name }} =
                {{
                sens_obj[sen.cond_senid].sen_type != 3
                ? sen.cond_value
                : sen.cond_value == "1"
                ? "ON"
                : "OFF"
                }}
                <span
                  v-if="sens_obj[sen.cond_senid].sen_type == 1"
                >
                  {{
                  sens_obj[sen.cond_senid].unit
                  }}
                </span>
              </div>
              <span
                v-else
                role="button"
                class="font-lg hover-show text-muted cell-title"
                @click="singleCreateCond(sen)"
              >
                <i class="iconfont icon-condition-control"></i>
              </span>
            </div>
            <div class="role-user">
              <span role="button" class="font-lg" @click="toggleShow(sen, 5)">
                <i v-if="sen.show_level_5" class="iconfont icon-eye-on text-success"></i>
                <i v-else class="iconfont icon-eye-off text-muted"></i>
              </span>
            </div>
            <div class="role-user">
              <span role="button" class="font-lg" @click="toggleShow(sen, 4)">
                <i v-if="sen.show_level_4" class="iconfont icon-eye-on text-success"></i>
                <i v-else class="iconfont icon-eye-off text-muted"></i>
              </span>
            </div>
            <div class="role-user">
              <span role="button" class="font-lg" @click="toggleShow(sen, 3)">
                <i v-if="sen.show_level_3" class="iconfont icon-eye-on text-success"></i>
                <i v-else class="iconfont icon-eye-off text-muted"></i>
              </span>
            </div>
            <div class="role-user">
              <span role="button" class="font-lg" @click="toggleShow(sen, 2)">
                <i v-if="sen.show_level_2" class="iconfont icon-eye-on text-success"></i>
                <i v-else class="iconfont icon-eye-off text-muted"></i>
              </span>
            </div>
            <div class="role-user">
              <span role="button" class="font-lg" @click="toggleShow(sen, 1)">
                <i v-if="sen.show_level_1" class="iconfont icon-eye-on text-success"></i>
                <i v-else class="iconfont icon-eye-off text-muted"></i>
              </span>
            </div>
          </div>
        </transition-group>
      </draggable>
      <div v-if="rw == 'R'" class="row-inner mb-lg">
        <div class="text-muted mt-lg mb pl text-bold">系统内置参数</div>
        <div v-for="sen in sysSens" :key="sen.senid" class="row-display">
          <div class="index font-lg">
            <i :class="sysIconEnum[sen.senid]" class="iconfont text-success"></i>
          </div>
          <div class="sen-name">
            <span v-if="sysEnum" class="sen-name-text">{{ sysEnum[sen.senid] }}</span>
          </div>
          <div class="role-user">
            <span role="button" class="font-lg" @click="toggleShowSys(sen, 5)">
              <i v-if="sen.show_level_5" class="iconfont icon-eye-on text-success"></i>
              <i v-else class="iconfont icon-eye-off text-muted"></i>
            </span>
          </div>
          <div class="role-user">
            <span role="button" class="font-lg" @click="toggleShowSys(sen, 4)">
              <i v-if="sen.show_level_4" class="iconfont icon-eye-on text-success"></i>
              <i v-else class="iconfont icon-eye-off text-muted"></i>
            </span>
          </div>
          <div class="role-user">
            <span role="button" class="font-lg" @click="toggleShowSys(sen, 3)">
              <i v-if="sen.show_level_3" class="iconfont icon-eye-on text-success"></i>
              <i v-else class="iconfont icon-eye-off text-muted"></i>
            </span>
          </div>
          <div class="role-user">
            <span role="button" class="font-lg" @click="toggleShowSys(sen, 2)">
              <i v-if="sen.show_level_2" class="iconfont icon-eye-on text-success"></i>
              <i v-else class="iconfont icon-eye-off text-muted"></i>
            </span>
          </div>
          <div class="role-user">
            <span role="button" class="font-lg" @click="toggleShowSys(sen, 1)">
              <i v-if="sen.show_level_1" class="iconfont icon-eye-on text-success"></i>
              <i v-else class="iconfont icon-eye-off text-muted"></i>
            </span>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <div v-if="sens.length > 0" class="operate-area flex-center">
      <el-button v-if="dataChanged" class="extend" plain @click="reset">重置</el-button>
      <el-button
        class="extend"
        :type="dataChanged ? 'success' : 'info'"
        :loading="posting"
        @click="submit"
      >保存设置</el-button>
    </div>

    <ConditionEditDialog
      v-if="showVisiableConditionEditDialog"
      :show.sync="showVisiableConditionEditDialog"
      :sensors="inputSensors"
      :open-type="openType"
      @submit="handleCondSumbit"
      @delete="handleCondDelete"
    />
    <!-- 批量排序弹框 -->
    <el-dialog
      title="排序设置"
      :visible.sync="showBatchSortDialog"
      width="30%"
      append-to-body
      modal-append-to-body
      :close-on-click-modal="false"
    >
      <div v-if="showBatchSortDialog">
        <div class="mb">
          将选中的
          <span class="text-primary">{{ selectedSens.length }}</span>
          个参数移动到
        </div>
        <el-select v-model="moveToIndex" class="mr" placeholder="请选择" filterable auto-complete>
          <el-option
            v-for="(item, index) in unSelectedSens"
            :key="item.senid"
            :label="item.sen_name"
            :value="index"
          ></el-option>
        </el-select>
        <el-select v-model="moveMethod" style="width: 100px">
          <el-option label="之前" :value="-1"></el-option>
          <el-option label="之后" :value="1"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer flex-center">
        <el-button @click="cancelSort">取消</el-button>
        <el-button type="primary" @click="handleSort">设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  listSenApi,
  rankSenApi,
  getSysSenListApi,
  saveSysSenApi,
} from "@/api/senApi";
import { array2Object } from "@/utils/common";

export default {
  name: "ReadSenRank",

  components: {
    draggable,
    ConditionEditDialog: () => import("./ConditionEditDialog.vue"),
  },

  props: {
    devid: {
      type: Number,
      default: undefined,
    },

    rw: {
      type: String,
      default: undefined,
    },

    sysEnum: {
      type: Object,
      default: undefined,
    },
    sysIconEnum: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    return {
      loading: false,
      sens: [],

      dataChanged: false,
      posting: false,
      all_checked: false,
      isIndeterminate: false,
      selectedSens: [],
      unSelectedSenst: [],
      openType: "single", // single | multi
      singleSensors: [],
      showVisiableConditionEditDialog: false,
      moveToIndex: null,
      moveMethod: 1,
      showBatchSortDialog: false,

      sysSens: [],
    };
  },

  computed: {
    equipAuthArr() {
      return this.$store.state.commonStore.equipAuthArr;
    },

    dev() {
      return this.$store.state.devStore.dev;
    },

    sens_obj() {
      const models = this.$store.state.devStore.models;
      if (models.length == 0) return [];

      let sens = [];
      models.forEach((v) => {
        if (this.dev.protocal == 'MQTT') {
          sens = sens.concat(v.sens)
        } else {
          if(v.cmd.cmdid) sens = sens.concat(v.sens);
        }
      });
      return array2Object(sens, "senid");
    },

    inputSensors() {
      return this.openType == "multi" ? this.selectedSens : this.singleSensors;
    },
  },

  watch: {
    sens: {
      deep: true,
      handler: function (val, oldVal) {
        this.$emit("onDataChange", val);
      },
    },
    dataChanged: function (val, oldVal) {
      this.$emit("dataChanged", val);
    },

    sysSens: {
      deep: true,
      handler: function (val, oldVal) {
        this.$emit("sysSensChange", val);
      },
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      listSenApi({
        devid: this.devid,
        sen_rw: this.rw,
      }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.sens = Object.assign([], res.data.list);
        }
      });
      if (this.rw != "R") {
        return;
      }
      getSysSenListApi().then((res) => {
        if (!res.errno) {
          this.sysSens = res.data.sys_sen_list;
        }
      });
    },

    toggleShowSys(sen, level) {
      const levelArr = [1, 2, 3, 4, 5];
      const idx = this.sysSens.indexOf(sen);
      const field = "show_level_" + level;
      const show = sen[field] ? 0 : 1;
      this.sysSens[idx][field] = show;
      this.dataChanged = true;

      // 快捷显隐
      levelArr.forEach((item) => {
        // 勾中低权限，则默认高权限也勾中
        if (show && item > level) {
          this.sysSens[idx]["show_level_" + item] = show;
        }
        // 取消高权限，则默认低权限也取消
        if (!show && item < level) {
          this.sysSens[idx]["show_level_" + item] = show;
        }
      });
    },

    toggleShow(sen, level) {
      const levelArr = [1, 2, 3, 4, 5];
      const idx = this.sens.indexOf(sen);
      const field = "show_level_" + level;
      const show = sen[field] ? 0 : 1;
      this.sens[idx][field] = show;
      this.dataChanged = true;

      // 快捷显隐
      levelArr.forEach((item) => {
        // 勾中低权限，则默认高权限也勾中
        if (show && item > level) {
          this.sens[idx]["show_level_" + item] = show;
        }
        // 取消高权限，则默认低权限也取消
        if (!show && item < level) {
          this.sens[idx]["show_level_" + item] = show;
        }
      });
    },

    singleCheckChange(val, index) {
      this.$set(this.sens[index], "checked", val);
      this.selectedSens = this.sens.filter((item) => item.checked);

      //判断是否全选
      const checkedCount = this.selectedSens.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.sens.length;
      this.all_checked = checkedCount === this.sens.length;
    },

    allCheckChange(val) {
      this.sens.forEach((item) => {
        this.$set(item, "checked", val);
      });
      this.selectedSens = val ? this.sens : [];
      this.isIndeterminate = false;
    },

    multiCreateCond() {
      this.openType = "multi";
      this.showVisiableConditionEditDialog = true;
    },

    singleCreateCond(sen) {
      this.openType = "single";
      this.singleSensors = [sen];
      this.showVisiableConditionEditDialog = true;
      // 清除多选状态
      this.sens.forEach((sen) => {
        this.$set(sen, "checked", false);
      });
      this.selectedSens = [];
      this.isIndeterminate = false;
      this.all_checked = false;
    },

    handleCondSumbit(cond) {
      this.showVisiableConditionEditDialog = false;
      this.inputSensors.forEach((sen) => {
        sen.cond_senid = cond.cond_senid;
        sen.cond_value = cond.cond_value;
      });
      // 如果为多选，则重置筛选
      if (this.openType == "multi") {
        this.sens.forEach((sen) => {
          sen.checked = false;
        });
        this.selectedSens = [];
        this.isIndeterminate = false;
        this.all_checked = false;
      }
      this.dataChanged = true;
    },

    handleCondDelete() {
      this.showVisiableConditionEditDialog = false;
      this.inputSensors.forEach((sen) => {
        sen.cond_senid = 0;
        sen.cond_value = 0;
      });
      this.dataChanged = true;
    },

    submit() {
      this.posting = true;
      let req1 = saveSysSenApi({ sys_sen_list: this.sysSens, devid: this.devid});
      let req2 = rankSenApi({
        devid: this.devid,
        sen_rw: this.rw,
        data: this.sens,
      });
      Promise.all([req1, req2]).then((values) => {
        this.posting = false;
        if (!values[0].errno && !values[1].errno) {
          this.reset();
          this.$message.success('操作成功');
          this.$store.dispatch("fetchDataAction");
          this.$emit("onSubmit", parseInt(+new Date() / 1000));
        } else {
          this.$message.error('操作失败');
        }
      });
    },

    reset() {
      this.dataChanged = false;
      this.all_checked = false;
      this.isIndeterminate = false;
      this.selectedSens = [];
      this.sens = [];
      // 重置移动位置
      this.moveToIndex = null;
      this.moveMethod = 1;
      this.fetchData();
    },

    moveTo() {
      this.showBatchSortDialog = true;
      this.unSelectedSens = this.sens.filter((item) => !item.checked);
    },

    handleSort() {
      if (this.moveToIndex === null) {
        this.$message.error("请选择移动位置");
        return;
      }
      const selectedSens = this.selectedSens;
      const unSelectedSens = this.unSelectedSens;
      const moveToIndex = this.moveToIndex;
      const moveMethod = this.moveMethod;
      const moveSens = selectedSens.map((item) => {
        return {
          ...item,
          checked: false,
        };
      });
      const newSens = unSelectedSens.slice();
      if (moveMethod == -1) {
        newSens.splice(moveToIndex, 0, ...moveSens);
      } else {
        newSens.splice(moveToIndex + 1, 0, ...moveSens);
      }
      this.sens = Object.assign([], newSens);
      this.showBatchSortDialog = false;
      this.dataChanged = true;
      // 清除多选状态
      this.sens.forEach((sen) => {
        this.$set(sen, "checked", false);
      });
      this.selectedSens = [];
      this.isIndeterminate = false;
      this.all_checked = false;
      // 重置移动位置
      this.moveToIndex = null;
      this.moveMethod = 1;
    },
    cancelSort() {
      this.showBatchSortDialog = false;
      // 重置移动位置
      this.moveToIndex = null;
      this.moveMethod = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.sen-rank {
  position: relative;
  height: 100%;
  .row-wrapper {
    height: calc(100% - 40px);
    .row-inner {
      padding-bottom: 10px;
    }
  }
  .row-display {
    min-height: 40px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    &:hover {
      background-color: #f5f7fa;
      .hover-show {
        display: block;
      }
    }
    &.sortable-chosen {
      background-color: #f0f9eb;
    }
    .index {
      width: 50px;
      text-align: center;
      .index-checkbox {
        display: none;
      }
      &:hover {
        .index-checkbox {
          display: inline-block;
        }
        .index-number {
          display: none;
        }
      }
    }
    .drag-button {
      width: 60px;
      text-align: center;
      cursor: move;
    }
    .sen-name {
      flex: 1;
      min-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .sen-name-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    .visiable-condition {
      width: 25%;
      min-width: 100px;
      text-align: center;
      .cell-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }

      &:hover {
        .cell-title {
          color: #07c160;
        }
      }
    }
    .role-user {
      width: 100px;
      text-align: center;
    }
  }
  .operate-area {
    position: fixed;
    left: 440px;
    right: 320px;
    bottom: 0;
    height: 60px;
    background-color: #fff;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    z-index: 100;
  }
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
